/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalStatistics
 */
export interface CarePrincipalStatistics {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalStatistics
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalStatistics
     */
    registeredTransactions?: number;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalStatistics
     */
    queries?: number;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalStatistics
     */
    queries1177?: number;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalStatistics
     */
    activeCards?: number;
    /**
     * 
     * @type {Date}
     * @memberof CarePrincipalStatistics
     */
    fromDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CarePrincipalStatistics
     */
    issuedCards?: number;
    /**
     * 
     * @type {Date}
     * @memberof CarePrincipalStatistics
     */
    toDate?: Date;
}

export function CarePrincipalStatisticsFromJSON(json: any): CarePrincipalStatistics {
    return CarePrincipalStatisticsFromJSONTyped(json, false);
}

export function CarePrincipalStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalStatistics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'registeredTransactions': !exists(json, 'registeredTransactions') ? undefined : json['registeredTransactions'],
        'queries': !exists(json, 'queries') ? undefined : json['queries'],
        'queries1177': !exists(json, 'queries1177') ? undefined : json['queries1177'],
        'activeCards': !exists(json, 'activeCards') ? undefined : json['activeCards'],
        'fromDate': !exists(json, 'fromDate') ? undefined : (new Date(json['fromDate'])),
        'issuedCards': !exists(json, 'issuedCards') ? undefined : json['issuedCards'],
        'toDate': !exists(json, 'toDate') ? undefined : (new Date(json['toDate'])),
    };
}

export function CarePrincipalStatisticsToJSON(value?: CarePrincipalStatistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'registeredTransactions': value.registeredTransactions,
        'queries': value.queries,
        'queries1177': value.queries1177,
        'activeCards': value.activeCards,
        'fromDate': value.fromDate === undefined ? undefined : (value.fromDate.toISOString().substr(0,10)),
        'issuedCards': value.issuedCards,
        'toDate': value.toDate === undefined ? undefined : (value.toDate.toISOString().substr(0,10)),
    };
}

